<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
  html{
    margin: 0;
    padding: 0;
    height: 100%;
  }
  body{
    margin: 0;
    padding: 0;
    height: 100%;
  }
#app {
  margin: 0;
  padding: 0;
  height: 100%;
  width:99.9%;
}

</style>



// WEBPACK FOOTER //
// src/App.vue